<template>
 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 53.333 53.333">
  <path d="M23.342 31.665l8.674-4.996-8.674-4.996z" clip-rule="evenodd"/>
  <path d="M26.663.003C11.938.003-.004 11.944-.004 26.669c0 14.726 11.942 26.667 26.667 26.667 14.725 0 26.666-11.941 26.666-26.667C53.33 11.944 41.39.003 26.663.003zm16.663 26.693s0 5.41-.687 8.016a4.173 4.173 0 01-2.937 2.937c-2.608.687-13.04.687-13.04.687s-10.403 0-13.038-.713a4.173 4.173 0 01-2.937-2.938C10 32.105 10 26.67 10 26.67s0-5.408.687-8.016a4.26 4.26 0 012.937-2.964c2.608-.686 13.039-.686 13.039-.686s10.43 0 13.039.713a4.173 4.173 0 012.937 2.937c.715 2.608.687 8.043.687 8.043z"/>
</svg>

</template>

<script>
export default {}
</script>
